export const PUBLICATION_LANDING_REQUEST = 'PUBLICATION_LANDING_REQUEST';
export const PUBLICATION_LANDING_SUCCESS = 'PUBLICATION_LANDING_SUCCESS';
export const PUBLICATION_LANDING_FAIL    = 'PUBLICATION_LANDING_FAIL';

